import React, {useState, FormEvent, useContext} from "react"
import {useMutation} from "@apollo/client"
import {Search} from "../Tmdb/Search"

import MUTATION_SHOW_ADD from "graphql/Media/Show/mutation/showAdd"
import {alertContext} from "context/Alert/alert"
import {BackofficePage, BackofficePanel} from "components/backoffice/Layout/BackofficePage"

export const ShowEdit = (props: any) => {


  const [mutate] = useMutation(MUTATION_SHOW_ADD)
  const {setMessage, setError} = useContext(alertContext)

  const [showName, updateName] = useState("")
  const [showTmdbOptions, updateTmdbOptions] = useState(null)

  const onChange = (name: string, tmdbOptions: any) => {
    updateName(name)
    updateTmdbOptions(tmdbOptions)
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    mutate({
      variables: {
        name: showName,
        tmdbOptions: showTmdbOptions
      }
    })
      .then(() => {
        setMessage("Série ajoutée au catalogue")
      })
      .catch(() => {
        setError("Impossible d'ajouter cette série")
      })
  }

  return <BackofficePage eyebrow="Catalogue" title="Ajouter une série" description="Recherchez une série dans TMDB puis ajoutez sa fiche au catalogue Zipflix." icon="fa-tv">
    <BackofficePanel title="Recherche TMDB" description="Sélectionnez la fiche officielle correspondant à la série." icon="fa-search">
      <form className="bo-media-create-form" onSubmit={onSubmit}>
        <div className="bo-form-column">
          <Search
            type='show'
            onChange={onChange}
          />
          {showName && <div className="bo-selection-confirmation"><span className="fas fa-check"></span><span><small>Série sélectionnée</small><strong>{showName}</strong></span></div>}
          <button className="bo-primary-action" disabled={!showName}><span className="fas fa-plus"></span>Ajouter la série</button>
        </div>
      </form>
    </BackofficePanel>
  </BackofficePage>
}
